/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const RelevanceIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Relevance',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M4.225 15.585a13.987 13.987 0 0 1 11.36-11.36A.494.494 0 0 0 16 3.74V2.721a.5.5 0 0 0-.578-.5 15.992 15.992 0 0 0-13.2 13.2.5.5 0 0 0 .5.578H3.74a.494.494 0 0 0 .485-.414ZM20.415 4.225a13.987 13.987 0 0 1 11.36 11.36.494.494 0 0 0 .485.415h1.019a.5.5 0 0 0 .5-.578 15.992 15.992 0 0 0-13.2-13.2.5.5 0 0 0-.578.5V3.74a.494.494 0 0 0 .414.485ZM15.585 31.775a13.987 13.987 0 0 1-11.36-11.36A.494.494 0 0 0 3.74 20H2.721a.5.5 0 0 0-.5.578 15.992 15.992 0 0 0 13.2 13.2.5.5 0 0 0 .578-.5V32.26a.494.494 0 0 0-.414-.485ZM31.775 20.415a13.987 13.987 0 0 1-11.36 11.36.494.494 0 0 0-.415.485v1.019a.5.5 0 0 0 .578.5 15.992 15.992 0 0 0 13.2-13.2.5.5 0 0 0-.5-.578H32.26a.494.494 0 0 0-.485.414Z"
    />
    <circle cx="18" cy="18" r="6" />
  </svg>`;
};
